import { useMutation } from '@tanstack/react-query'
import { showNotification } from '@mantine/notifications'
import type { OrpcClient } from '@/orpc/client'
import { useOrpc } from './useClient'
import { useMedplum } from '@medplum/react'

export type InviteOrgMemberInput = Parameters<OrpcClient['inviteOrgMember']>[0]

export function useInviteOrgMember() {
  const medplum = useMedplum()
  const orpc = useOrpc()

  return useMutation(
    orpc.inviteOrgMember.mutationOptions({
      onSuccess: () => {
        medplum.invalidateSearches('Practitioner')
        medplum.invalidateSearches('ProjectMembership')
      },
      onError: (error) => {
        showNotification({
          color: 'red',
          title: 'Invitation failed',
          message: error instanceof Error ? error.message : 'Unknown error',
        })
      },
    }),
  )
}
